import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@/components/atoms/Button/Button';
import { DeleteIcon } from '@/components/atoms/Icon/DeleteIcon';
import { VisibilityIcon } from '@/components/atoms/Icon/VisibilityIcon';
import Card from '@/components/molecules/Card/Card';
import QuickviewModal from '@/components/organisms/QuickviewModal/QuickviewModal';
import { cn } from '@/utils/cn';
import * as React from 'react';
const CollectionGridCard = ({ card, model, quickViewLabel, viewFullProjectLabel, isSharedView, className, setRemoveModalOpen, setSelectedContentId, ...rest }) => {
    const [openQuickview, setOpenQuickview] = React.useState(false);
    const { ctAs, url } = card;
    const componentGuid = model?.componentGuid;
    const isArticle = model && 'articleType' in model;
    const primaryLink = ctAs?.[0] || {
        url: url,
        text: viewFullProjectLabel || 'View Full Project',
    };
    const handleRemoveModelOpen = () => {
        if (setSelectedContentId && componentGuid) {
            setSelectedContentId(componentGuid);
            setRemoveModalOpen?.(true);
        }
    };
    return (_jsxs("div", { className: cn('bg-surface-primary-default border-stroke-default-default flex w-full flex-col gap-4 rounded-sm border px-5 pt-4 pb-6', className), ...rest, children: [!isSharedView && (_jsx(Button, { variant: "tertiary", size: "icon-small", className: "w-fit self-end", onClick: handleRemoveModelOpen, children: _jsx(DeleteIcon, { className: "h-5 w-5" }) })), _jsx(Card, { variant: 'standard', card: card }), model && !isArticle && quickViewLabel && (_jsx(QuickviewModal, { block: model, isModalOpen: openQuickview, onClose: () => setOpenQuickview(false), triggerButton: _jsxs(Button, { variant: "menu-option", size: "small", className: "w-fit", onClick: () => setOpenQuickview(true), children: [_jsx(VisibilityIcon, { className: "h-5 w-5" }), quickViewLabel] }), cta: primaryLink }))] }));
};
export default CollectionGridCard;
